import "./Contact_text.css";

import GithubImg from "./images/GitHub-Mark-Light-120px-plus.png";
import LinkedinImg from "./images/logo-large-linkedin.png";
import EmailImg from "./images/logo-large-email.png";

const ContactText = () =>
{
	return(
		<div>
			<p>Here's my contact info. It's also available in the footer-bar of all pages.</p>

			<div className="contact-element">
				<img src={EmailImg} alt="email logo" className="left"/>

				<span className="right">
					<h2>My email address</h2>
					<p>maxskan98@gmail.com</p>
					<p><a href="mailto:maxskan98@gmail.com">mail link</a></p>
				</span>
			</div>

			<div className="contact-element">
				<img src={GithubImg} alt="github logo" className="left"/>

				<span className="right">
					<h2>My GitHub page</h2>
					<p>@maxska</p>
					<p><a href="https://github.com/maxska" target="_blank" rel="noopener noreferrer">github.com/maxska</a></p>
				</span>
			</div>

			<div className="contact-element">
				<img src={LinkedinImg} alt="logo" className="left"/>

				<span className="right" style={{position: "absolute", marginTop: "5px"}}>
					<h2>My LinkedIn profile</h2>
					<a href="https://se.linkedin.com/in/max-skanvik" target="_blank" rel="noopener noreferrer">profile link</a>
				</span>
			</div>

		</div>
	)
}

export default ContactText;